export default {
    getJWT() {
        const match = document.cookie.match(/(?:^|;\s*)PORTAL-JWT=([^;]+)/);
        if (!match) return "";

        try {
            const token = match[1];
            const payloadBase64Url = token.split(".")[1];
            if (!payloadBase64Url) return "";

            // Base64URL → Base64
            const base64 = payloadBase64Url
                .replace(/-/g, "+")
                .replace(/_/g, "/")
                .padEnd(payloadBase64Url.length + ((4 - (payloadBase64Url.length % 4)) % 4), "=");

            // Base64 → binary
            const binary = window.atob(base64);

            // binary → Uint8Array
            const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));

            // UTF-8 decode
            const json = new TextDecoder("utf-8").decode(bytes);

            return JSON.parse(json);
        } catch (e) {
            console.error(e);
            return "";
        }
    },
    // jwt 토큰 내 아이디 반환
    getUser() {
        return this.getJWT().sub ?? "";
    },
    // jwt 토큰 내 권한코드 반한
    getRole() {
        return this.getJWT().role ?? "";
    },
    // makrCd, 제조사명 정보 반환
    getMakrInfo() {
        try {
            const token = this.getJWT();

            // const bytes = Uint8Array.from(window.atob(token), (c) => c.charCodeAt(0));
            return {
                makrCode: token.makrCode,
                makrName: token.makrName,
            };
        } catch (e) {
            console.log(e);
            return "";
        }
    },
    // jwt 토큰 내 권한유형 반한
    getRoleType() {
        return this.getJWT().roleType ?? "";
    },
    getGuestType() {
        return this.getJWT().guestType ?? "";
    },
    hasToken() {
        const match = document.cookie.match(/(?:^|;\s*)PORTAL-JWT=([^;]+)/);
        try {
            return match ? true : false;
        } catch (e) {
            console.log(e);
            return "";
        }
    },
};
